import { useRef, useEffect } from 'react';
import ImageWMSSource from 'ol/source/ImageWMS';
import OLImageLayer from 'ol/layer/Image';
import { getAbsoluteUrl } from '@tmapy/utils';
import { useOLMap } from '../MapContext';
import { useLayerEffect } from './useLayerEffect';
import { getCrossOriginValue } from './getCrossOriginValue';
import { fetchAndSetAuthorizedImage } from './utils';
export const ImageWMSLayer = (props) => {
    const map = useOLMap();
    const layerRef = useRef(null);
    useLayerEffect(layerRef, props.layerOptions);
    useEffect(() => {
        const projection = map.getView().getProjection();
        const sourceParams = {
            ...props.sourceOptions,
            projection,
            crossOrigin: getCrossOriginValue(props.sourceOptions.url),
            wrapX: projection.isGlobal(),
            attributions: props.sourceOptions.attributions,
            imageLoadFunction: (image, src) => {
                const params = props.getUrlParams?.();
                ['CRS', 'SRS'].forEach((crs) => {
                    if (props.sourceOptions.params?.[crs]) {
                        src = src.replace(new RegExp(crs + '=([^&]+)'), `${crs}=${encodeURI(props.sourceOptions.params[crs])}`);
                    }
                });
                if (params && src) {
                    const url = getAbsoluteUrl(src);
                    for (const key in params) {
                        if (key !== 'jwt') {
                            url.searchParams.set(key, params[key]);
                        }
                    }
                    src = url.toString();
                }
                if (props.auth && params?.jwt) {
                    fetchAndSetAuthorizedImage(src, params.jwt, image);
                }
                else {
                    image.getImage().src = src;
                }
            },
            serverType: 'mapserver',
        };
        for (const key in sourceParams.params) {
            if (!sourceParams.params.hasOwnProperty(key))
                continue;
            const upper = key.toUpperCase();
            // jestlize byla korekce parametru jiz provedena, nebo je parametr spravne nastaven neprovede ji opakovane
            if (upper !== key && !sourceParams.params.hasOwnProperty(upper)) {
                sourceParams.params[upper] = sourceParams.params[key];
                delete sourceParams.params[key];
            }
        }
        const layer = new OLImageLayer({
            ...{ id: props.id },
            source: new ImageWMSSource(sourceParams),
            visible: props.layerOptions.visible,
            opacity: props.layerOptions.opacity ?? 1,
            minResolution: props.layerOptions.minResolution,
            maxResolution: props.layerOptions.maxResolution,
            zIndex: props.layerOptions.zIndex,
        });
        layerRef.current = layer;
        map.addLayer(layer);
        if (process.env.NODE_ENV === 'development') {
            console.debug('new ImageWMSLayer', map, layerRef.current);
        }
        return () => {
            // unmount
            const layer = layerRef.current;
            if (layer) {
                map.removeLayer(layer);
                layer.dispose();
                layerRef.current = null;
            }
        };
    }, [map, props.sourceOptions]);
    return null;
};
//# sourceMappingURL=ImageWMSLayer.js.map